module.exports = __webpack_public_path__ + "static/img/issue.12a81091.png";